import { Component, OnInit } from '@angular/core';
import { ScrollHelper } from '../helpers/ScrollHelper';

@Component({
  selector: 'app-scroll-top',
  templateUrl: './scroll-top.component.html',
  styleUrls: ['./scroll-top.component.scss']
})
export class ScrollTopComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  scrollToTop(){
    ScrollHelper.smoothScroll(0);
  }

}
